import React, { useState } from 'react';
import { Select, Space } from 'antd';

const options = [];
for (let i = 10; i < 36; i++) {
    const value = i.toString(36) + i;
    options.push({
        label: `Long Label: ${value}`,
        value,
    });
}

const SelectInput = () => {
    const [value, setValue] = useState([]);
    const selectProps = {
        mode: 'multiple',
        style: {
            width: '100%',
        },
        value,
        options,
        onChange: (newValue) => {
            setValue(newValue);
        },
        placeholder: 'Ekin turi',
        maxTagCount: 'responsive',
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{
                    width: '100%',
                }}
            >
                <Select {...selectProps} />
            </Space>
        </>
    );
};

export default SelectInput;